<mat-form-field>
    <mat-label>{{ "subject_job" | transloco }}</mat-label>
    <mat-select #competencyFilter (valueChange)="onChangeEvent($event)">
        <mat-option [value]="">---</mat-option>
        @for (competency of competencies; track competency) {
            <mat-option [value]="competency.treeId">{{ competency.name }}</mat-option>
        }
    </mat-select>
</mat-form-field>
